import React, { useState } from 'react'
import { Loading } from '@guillotinaweb/react-gmi'
import { useMutation, useQuery } from 'urql'
import { Input, Form, Button, Alert, message, Switch } from 'antd'

import { ContentLayout, Error } from '../../common/content-layout'
import { UserSelector } from '../../components/user-selector'

import './styles.css'

const UserQuery = `
  query ($userId: Int) {
    user(id_usuario: $userId) {
      id
      email
      nombre
      idioma
      country
      observaciones
      subscription {
        unsubscribed
      }
    }
  }
`

const UserMutation = `
  mutation ($input: inputUpdateUser) {
    user_update(input: $input) {
      status
    }
  }
`

export function Users() {
  const countryWarn = 'Country length should be 2'
  const langWarn = 'Language length should be 2'
  const [loading, setLoading] = useState(false)
  const [, save] = useMutation(UserMutation)
  const [userId, setUserId] = useState()
  const [res] = useQuery({
    query: UserQuery,
    variables: { userId },
    pause: !userId,
  })

  const newsletter = !res.data?.user?.subscription?.unsubscribed

  return (
    <ContentLayout className="admin-users" title="Users">
      <Form.Item label="Email">
        <UserSelector
          style={{ width: 400 }}
          onChange={(u) => setUserId(u.id_usuario)}
        />
      </Form.Item>
      {!userId && (
        <div style={{ padding: '0 50px' }}>
          <Alert
            message="Search a user"
            description="To edit a user's fields you must search for the user by the email field."
            type="info"
            showIcon
          />
        </div>
      )}
      {res.fetching && <Loading />}
      {res.error && <Error message={res.error.message} />}
      {res.data && !res.fetching && (
        <Form
          name="basic"
          key={res.data.user.email}
          initialValues={{ ...res.data.user, newsletter }}
          onFinish={async (form) => {
            try {
              setLoading(true)
              const user_id = res.data.user.id
              const input = { user_id, ...form }
              const r = await save({ input })
              if (r.error?.message) return message.error(r.error?.message)
              message.success('Saved!')
            } catch (e) {
              message.error(e.message)
            } finally {
              setLoading(false)
            }
          }}
        >
          <Form.Item label="Name" name="nombre">
            <Input />
          </Form.Item>
          <Form.Item
            label="Language"
            name="idioma"
            rules={[
              { min: 2, message: langWarn },
              { max: 2, message: langWarn },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Country"
            name="country"
            rules={[
              { min: 2, message: countryWarn },
              { max: 2, message: countryWarn },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item label="Observations" name="observaciones">
            <Input.TextArea />
          </Form.Item>
          <Form.Item label="Newsletter" name="newsletter">
            <Switch defaultChecked={newsletter} />
          </Form.Item>
          <Form.Item>
            <Button
              style={{ marginLeft: 'auto' }}
              disabled={loading}
              type="primary"
              htmlType="submit"
            >
              Save
            </Button>
          </Form.Item>
          {loading && <Loading />}
        </Form>
      )}
    </ContentLayout>
  )
}
